export default "/images/d2eca69bbdea6a78acf1090c1260aed5.avif";